export default __webpack_public_path__ + "static/media/FISH-MATIC.e46b9312.svg";